export const FETCH_MOVIES = "FETCH_MOVIES";
export const FETCH_TRENDING = "FETCH_TRENDING";
export const FETCH_UPCOMING = "FETCH_UPCOMING";
export const FETCH_MOVIE_DETAILS = "FETCH_MOVIE_DETAILS";
export const FETCH_CREDITS = "FETCH_CREDITS";
export const FETCH_TOP_RATED = "FETCH_TOP_RATED";
export const FETCH_NOW_PLAYING = "FETCH_NOW_PLAYING";
export const FETCH_POPULAR = "FETCH_POPULAR";
export const FETCH_TRAILERS = "FETCH_TRAILERS";
export const FETCH_SIMILAR_MOVIE = "FETCH_SIMILAR_MOVIE";
export const FETCH_GENRES = "FETCH_GENRES";
export const FETCH_ACTOR = "FETCH_ACTOR";
export const FETCH_ACTOR_MOVIES = "FETCH_ACTOR_MOVIES";

//tv shows
export const FETCH_TV_POPULAR = "FETCH_TV_POPULAR";
export const FETCH_TV_TOP_RATED = "FETCH_TV_TOP_RATED";
export const FETCH_TV_ON_AIR = "FETCH_TV_ON_AIR";
export const FETCH_TV_AIRING_TODAY = "FETCH_TV_AIRING_TODAY";
export const FETCH_TV_TRENDING = "FETCH_TV_TRENDING";
export const FETCH_SHOW_DETAILS = "FETCH_SHOW_DETAILS";
export const FETCH_SHOW_VIDEOS = "FETCH_SHOW_VIDEOS";
export const FETCH_SHOW_CREDITS = "FETCH_SHOW_CREDITS";
export const FETCH_SHOW_SIMILAR = "FETCH_SHOW_SIMILAR";

//signin
export const CREATE_SIGN_IN_TOKEN = "CREATE_SIGN_IN_TOKEN";
export const CREATE_SIGN_IN_SESSION = "CREATE_SIGN_IN_SESSION";
export const DELETE_SIGN_OUT_SESSION = "DELETE_SIGN_OUT_SESSION";

//account
export const FETCH_ACCOUNT_DETAILS = "FETCH_ACCOUNT_DETAILS";
export const FETCH_FAVORITE_MOVIES = "FETCH_FAVORITE_MOVIES";
export const FETCH_FAVORITE_SHOWS = "FETCH_FAVORITE_SHOWS";
export const POST_FAVORITE = "POST_FAVORITE";
